import { gsap } from "gsap/all";
import * as bodyScrollLock from "body-scroll-lock";

var disableBodyScroll = bodyScrollLock.disableBodyScroll;
var enableBodyScroll = bodyScrollLock.enableBodyScroll;
class DropdownHeader {
    constructor(selector, selectorContainer) {
        this.navbar = document.querySelector(selector);
        this.buttons = this.navbar.querySelectorAll('button[data-expandible]');
        this.container = document.querySelector(selectorContainer);
        this.contents = this.container.querySelectorAll('div[data-expandible]');
        this.navbar = document.querySelector('.navbar');
        this.header = document.querySelector('.header');

        this.buttons.forEach(button => {

            button.addEventListener('click', (e) => {
                var data = button.getAttribute('data-expandible');
                this.toggleDropdown(e, data);
            })

        });

    }

    toggleDropdown(e, data) {
        e.preventDefault();
        e.stopPropagation();
        var dataButton = data;

        this.contents.forEach(content => {
            var dataContent = content.getAttribute('data-expandible');

            if (dataContent == dataButton) {
                content.classList.remove('close')
                if (!content.classList.contains('open')) {
                    this.openDropdown(content);

                } else {
                    this.closeDropdown(content);

                }
            } else if (content.classList.contains('open')) {
                this.closeDropdown(content);

            }
        })
    }

    openDropdown(content) {
        const optionsBodyScroll =  {
            reserveScrollBarGap: true,
          };
           
        
        disableBodyScroll(content, optionsBodyScroll);


        content.classList.add('open'); //flag para open

        gsap.to(content.querySelector(".collapseDiv--items"), .5, {
            height: 'auto', //495
            marginTop: 25,
            marginBottom: 25,
            opacity: 1,
            top: 0,
        });
        //prevent scrollbar to display while opening, enable back when transition is over
        content.style.overflow = "hidden";
        gsap.delayedCall(0.5, () => {
            content.style.overflow = "auto";
        })

        content.addEventListener('click', () => {
            this.closeDropdown(content);
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth < 992) {
                this.closeDropdown(content)
            }
        });

        window.addEventListener('click', () => {
            this.closeDropdown(content);
        });

    }


    closeDropdown(content) {

        
        
        enableBodyScroll(content);

        content.classList.remove('open');

        gsap.to(content.querySelector(".collapseDiv--items"), .5, {
            height: 0,
            opacity: 0,
            top: 120,
            marginTop: 0,
            marginBottom: 0
        });
        //prevent scrollbar to display while opening, enable back when transition is over
        content.style.overflow = "hidden";
        gsap.delayedCall(0.5, () => {
            content.style.overflow = "auto";
        })

    }
}



export { DropdownHeader };